import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {Yii} from "../../interfaces/Yii";
import {IGetBookingsCommonResponse} from "../../service/resources/booking/interfaces/IGetBookings";
import {BookingType} from "../../service/resources/booking/interfaces/get-bookings.enum";
import {EAirBookingPermissions} from "../booking-information/e-air-booking-permissions.enum";
import {IAirTotal} from "../../service/resources/model/search/air/IAirTotal";
import {PermissionResourceService} from "../../service/resources/permission/permissionResource.service";

class Wording {
    public readonly cost: string = Yii.t("wui-sasha-js", "Total des tarifications\u00a0:");
    public readonly retail: string = Yii.t("wui-sasha-js", "Total prix de vente\u00a0:");
    public readonly price: string = Yii.t("wui-sasha-js", "Prix Total\u00a0:");
    public readonly pending: string = Yii.t("wui-shared-js", "Valeur restante des billets\u00a0:");
    public readonly used: string = Yii.t("wui-shared-js", "Valeur consommée des billets\u00a0:");
    public readonly issued: string = Yii.t("wui-shared-js", "Total des billets émis\u00a0:");
}

@Component({
    selector: 'search-form-price',
    template: `
        <div class="price" *ngIf="booking.type && booking.type[0] === bookingType.air">
            <ng-container *permissionIf="airBookingPermissions.SHARED_AIR_BOOKING_PRICE_SHOW">
                <div *ngFor="let price of prices" class="price-container">
                    <ng-container *ngIf="price?.xType">
                        <div class="label-container">{{labels[price.xType]}}</div>
                        <div class="price-element"><span
                                [innerHtml]="price?.amount | priceRealAmount:price.currency"></span></div>
                    </ng-container>
                </div>
            </ng-container>
            <ng-container *ngIf="historyPrices">
                <ng-container *permissionIf="airBookingPermissions.SHARED_AIR_BOOKING_PRICE_HISTORY_SHOW">
                    <div class="price-container">
                        <div class="label-container">{{labels.issued}}</div>
                        <div class="price-element"><span
                                [innerHtml]="historyPrices.history.issuedValue | price:historyPrices.history.currency"></span>
                        </div>
                    </div>
                    <div class="price-container">
                        <div class="label-container">{{labels.used}}</div>
                        <div class="price-element"><span
                                [innerHtml]="historyPrices.history.usedValue | price:historyPrices.history.currency"></span>
                        </div>
                    </div>
                    <div class="price-container">
                        <div class="label-container">{{labels.pending}}</div>
                        <div class="price-element"><span
                                [innerHtml]="historyPrices.history.pendingValue | price:historyPrices.history.currency"></span>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
            <span *ngIf="!prices?.length">-</span>
        </div>
        <div class="price" *ngIf="booking.type && booking.type[0] === bookingType.stay">
            <div *ngFor="let price of prices">
                <span *ngIf="price.xType && price.xType === 'cost' && hasRetailPrice">{{labels.cost}}</span>
                <span *ngIf="price.xType && price.xType === 'retail' && hasCostPrice">{{labels.retail}}</span>
                <span [innerHtml]="price?.amount | priceRealAmount:price?.currency"></span>
            </div>
            <span *ngIf="!prices?.length">-</span>
        </div>
        <div class="price" *ngIf="booking.type && booking.type[0] === bookingType.vehicleRental">
            <div *ngFor="let price of prices">
                <span [innerHtml]="price?.amount | priceRealAmount:price?.currency"></span>
            </div>
            <span *ngIf="!prices?.length">-</span>
        </div>
        <div class="price" *ngIf="!booking.type"></div>
        <div class="price"
             *ngIf="booking.type?.length && booking.type[0] !== bookingType.vehicleRental && booking.type[0] !== bookingType.air && booking.type[0] !== bookingType.stay">
            &nbsp;
        </div>
    `,
    styles: [`
        .price {
            text-align: start;
        }

        .price-element {
            font-weight: bolder;
        }
    `]
})

export class SearchFormPriceComponent implements OnInit {
    @Input()
    public booking: IGetBookingsCommonResponse;


    public labels: Wording = new Wording();
    public bookingType: typeof BookingType = BookingType;
    public airBookingPermissions: typeof EAirBookingPermissions = EAirBookingPermissions;
    public prices: IAirTotal[];
    public historyPrices: IAirTotal;
    public showCostPrice: boolean = false;
    public showRetailPrice: boolean = false;
    public hasCostPrice: boolean = false;
    public hasRetailPrice: boolean = false;

    constructor(
        private readonly permissionResource: PermissionResourceService) {
    }

    public ngOnInit(): void {
        this.permissionResource.getPermissionsStartingWith(['shared', 'stay', 'price']).subscribe((permissions: Set<string>): void => {
            this.showCostPrice = permissions.has('shared.stay.price.cost.show');
            this.showRetailPrice = permissions.has('shared.stay.price.retail.show');
            this.getFilteredPrices();
        });
    }

    private getFilteredPrices(): void {
        this.prices = this.booking
            && this.booking.total
            && this.booking.total.filter((price: IAirTotal): boolean => {
                return price.currency && price.amount !== undefined &&
                    (!price.xType ||
                        (price.xType && (
                                (price.xType === 'retail' && this.showRetailPrice) ||
                                (price.xType === 'cost' && this.showCostPrice) ||
                                (price.xType !== 'retail' && price.xType !== 'cost')
                            )
                        )
                    );
            });

        this.hasCostPrice = Boolean((this.prices || []).find((price: IAirTotal): boolean => price.xType === 'cost'));
        this.hasRetailPrice = Boolean((this.prices || []).find((price: IAirTotal): boolean => price.xType === 'retail'));
    }
}
